var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"agency-project-name"},[_c('v-layout',{attrs:{"row":""}},[_c('h1',[_vm._v("Projekt ("+_vm._s(_vm.value)+")")])]),_c('br')],1)}
var staticRenderFns = []

export { render, staticRenderFns }